var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.84975 15.8514H13.8495C16.689 15.8514 18.999 18.1614 18.999 21.0009V21.8514H20.7V21.0009C20.7 17.2239 17.6265 14.1504 13.8495 14.1504H9.84975C6.07275 14.1511 3 17.2239 3 21.0009V21.8514H4.70025V21.0009C4.70025 18.1614 7.01025 15.8514 9.84975 15.8514Z",
    fill: "#656565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.85 12.8519C14.5238 12.8519 16.7003 10.6761 16.7003 8.00162C16.7003 5.32712 14.5238 3.15137 11.85 3.15137C9.17551 3.15137 6.99976 5.32712 6.99976 8.00162C6.99976 10.6761 9.17551 12.8519 11.85 12.8519ZM11.85 4.85162C13.5863 4.85162 14.9993 6.26462 14.9993 8.00162C14.9993 9.73787 13.5863 11.1516 11.85 11.1516C10.113 11.1516 8.70001 9.73862 8.70001 8.00162C8.70001 6.26462 10.113 4.85162 11.85 4.85162Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsUser);
export default __webpack_public_path__ + "static/media/icons-user.703d9029e62b9e2ddbab86bd00ba27b2.svg";
export { ForwardRef as ReactComponent };